export const hiringManagerMentorJobsConstants = {
  //get accept reject mentor
  GET_ACCEPT_REJECT_MENTOR_HIRING_MANAGER_ACTION_REQUEST:
    "GET_ACCEPT_REJECT_MENTOR_HIRING_MANAGER_ACTION_REQUEST",
  GET_ACCEPT_REJECT_MENTOR_HIRING_MANAGER_ACTION_SUCCESS:
    "GET_ACCEPT_REJECT_MENTOR_HIRING_MANAGER_ACTION_SUCCESS",
  GET_ACCEPT_REJECT_MENTOR_HIRING_MANAGER_ACTION_FAILURE:
    "GET_ACCEPT_REJECT_MENTOR_HIRING_MANAGER_ACTION_FAILURE",

  //accept reject mentor
  ACCEPT_REJECT_MENTOR_HIRING_MANAGER_ACTION_REQUEST:
    "ACCEPT_REJECT_MENTOR_HIRING_MANAGER_ACTION_REQUEST",
  ACCEPT_REJECT_MENTOR_HIRING_MANAGER_ACTION_SUCCESS:
    "ACCEPT_REJECT_MENTOR_HIRING_MANAGER_ACTION_SUCCESS",
  ACCEPT_REJECT_MENTOR_HIRING_MANAGER_ACTION_FAILURE:
    "ACCEPT_REJECT_MENTOR_HIRING_MANAGER_ACTION_FAILURE",

  //all mentors applied on job
  GET_ALL_MENTORS_APPLIED_HIRING_MANAGER_ACTION_REQUEST:
    "GET_ALL_MENTORS_APPLIED_HIRING_MANAGER_ACTION_REQUEST",
  GET_ALL_MENTORS_APPLIED_HIRING_MANAGER_ACTION_SUCCESS:
    "GET_ALL_MENTORS_APPLIED_HIRING_MANAGER_ACTION_SUCCESS",
  GET_ALL_MENTORS_APPLIED_HIRING_MANAGER_ACTION_FAILURE:
    "GET_ALL_MENTORS_APPLIED_HIRING_MANAGER_ACTION_FAILURE",

  //all mentors applied on job
  GET_SUGGESTED_MENTORS_HIRING_MANAGER_ACTION_REQUEST:
    "GET_SUGGESTED_MENTORS_HIRING_MANAGER_ACTION_REQUEST",
  GET_SUGGESTED_MENTORS_HIRING_MANAGER_ACTION_SUCCESS:
    "GET_SUGGESTED_MENTORS_HIRING_MANAGER_ACTION_SUCCESS",
  GET_SUGGESTED_MENTORS_HIRING_MANAGER_ACTION_FAILURE:
    "GET_SUGGESTED_MENTORS_HIRING_MANAGER_ACTION_FAILURE",

  //all mentors applied on job
  VIEW_MENTOR_PUBLIC_PROFILE_HIRING_MANAGER_ACTION_REQUEST:
    "VIEW_MENTOR_PUBLIC_PROFILE_HIRING_MANAGER_ACTION_REQUEST",
  VIEW_MENTOR_PUBLIC_PROFILE_HIRING_MANAGER_ACTION_SUCCESS:
    "VIEW_MENTOR_PUBLIC_PROFILE_HIRING_MANAGER_ACTION_SUCCESS",
  VIEW_MENTOR_PUBLIC_PROFILE_HIRING_MANAGER_ACTION_FAILURE:
    "VIEW_MENTOR_PUBLIC_PROFILE_HIRING_MANAGER_ACTION_FAILURE",


  //all applied mentor list
  GET_ALL_APPLIED_MENTOR_ACTION_REQUEST:
    "GET_ALL_APPLIED_MENTOR_ACTION_REQUEST",
  GET_ALL_APPLIED_MENTOR_ACTION_SUCCESS:
    "GET_ALL_APPLIED_MENTOR_ACTION_SUCCESS",
  GET_ALL_APPLIED_MENTOR_ACTION_FAILURE:
    "GET_ALL_APPLIED_MENTOR_ACTION_FAILURE",
};
